var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgO(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 146,
    viewBox: "0 0 153 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.493 34.5749C135.472 24.191 126.485 15.814 115.664 10.4911C104.582 4.99374 91.5805 2.20142 76.659 2.20142C61.7375 2.20142 49.2593 4.99374 38.09 10.4911C27.1825 15.814 18.1075 24.191 11.912 34.5749C5.62929 45.2206 2.48792 57.9606 2.48792 73.0566C2.48792 87.8908 5.62929 100.718 11.912 111.364C18.0202 121.835 27.1825 130.299 38.09 135.535C49.2593 141.119 62.0866 143.912 76.659 143.912C91.2314 143.912 104.495 141.119 115.664 135.535C126.485 130.212 135.472 121.748 141.493 111.364C147.776 100.718 150.83 87.8908 150.83 73.0566C150.83 57.9606 147.776 45.2206 141.493 34.5749ZM93.2384 92.6029C91.755 97.4022 89.748 100.805 86.9557 102.987C84.1634 105.168 80.7602 106.128 76.5717 106.128C72.9068 106.128 69.3292 105.081 66.275 102.987C63.4827 100.805 61.3012 97.4022 59.8178 92.6029C58.3344 87.8036 57.6363 81.2591 57.6363 73.1439C57.6363 65.0287 58.3344 58.3969 59.8178 53.5104C61.3012 48.6238 63.3955 45.2206 66.275 43.1264C69.3292 41.0322 72.9068 39.985 76.5717 40.0723C80.7602 40.0723 84.1634 41.1194 86.9557 43.0391C89.748 44.9589 91.755 48.5365 93.2384 53.4231C94.7218 58.3097 95.4199 64.8542 95.4199 73.0566C95.4199 81.2591 94.6346 87.8036 93.2384 92.6029Z",
    fill: "#191818",
    stroke: "#F57423",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgO);
export default __webpack_public_path__ + "static/media/o.ee72d4e72fff17cf4487dd9a181e8efe.svg";
export { ForwardRef as ReactComponent };